module.exports = __webpack_public_path__ + "static/img/better.6867fdcc.png";